import React, { useEffect, useState } from "react";
import { IconButton } from "@material-ui/core";
import { find, get, set } from "lodash";

import Button from "components/CustomButtons/Button.jsx";
import CustomDialogChooser from "components/CustomDialog/CustomDialogChooser";
import CustomDialogWithContact from "components/CustomDialog/CustomDialogWithContact";
import CustomInput from "components/CustomInput/CustomInputValidate.jsx";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Table from "components/Table/Table.jsx";
import { clone } from "shared/utility";
import { required } from "shared/validation";
import { determineIfActive, generateCommissionSplitData } from '../RSheetsLogic';
import { formatDollar, parseFloatString, theVal, twoDecimals } from "../../../shared/utility";
import { commissionCalc } from "./CommissionLogic";
import { getUser } from "../../../shared/authValidation";
import CustomCheckbox from "../../../components/CustomCheckbox/CustomCheckbox";
import AttachedCommissionSplits from "./AttachedCommissionSplits";

const CommissionSplits = (props) => {
    const {
        data, // all data
        updateDataObj, // updates a field's value e.g. updateDataObj(field, value);
        getContact,
        setData,
        lesseeLabel = 'Lessee',
        lessorLabel = 'Lessor',
        hideLessorOutsideBroker,
        show_assignor
    } = props;
    
    const [addAgent, setAddAgent] = useState(false);
    const [addAgent2, setAddAgent2] = useState(false);
    const [addAgent3, setAddAgent3] = useState(false);

    const hasLesseeAssociate = get(data, 'illi_represented_lessee', '') !== 'No'
    const hasLessorAssociate = get(data, 'illi_represented_lessor', '') !== 'No'
    const hasAssignorAssociate = get(data, 'illi_represented_assignor', '') !== 'No'
    const user = getUser();

    useEffect(() => {
        generateCommissionSplitData(data, setData)
    }, [])

    const buildAgentTableData = (type) => {
        let dataField;
        let field;
        console.log('usar', user.permObj);
        const canHideAssociates = user?.permObj?.hasOwnProperty('Routing can_hide_associate_on_invoice') ?? false;

        if (type === "Lessor") {
            dataField = data.commission_splits_agent;
            field = "commission_splits_agent";
        } else if (type === "Lessee") {
            dataField = data.commission_splits_agent2;
            field = "commission_splits_agent2";
        } else if (type === "Assignor") {
            dataField = data.commission_splits_agent3 ? data.commission_splits_agent3 : [];
            field = "commission_splits_agent3";
        }
        let tableData = dataField.map((user, index) => {
            return [
                <div>{user.Name} {user?.dba_name ? `DBA ${user.dba_name} ` : ''}
                {user?.dba_active == 0 && <span style={{color: 'red',fontWeight: 'bold'}}>(removed)</span>}
                </div>,
                <CustomInput
                    validate={[]}
                    value={user.Percentage}
                    type="number"
                    onChange={(e) => {
                        let newSplits = clone(dataField);
                        newSplits[index].Percentage = e.target.value;
                        updateDataObj(field, newSplits);
                    }}
                />,
                canHideAssociates && <CustomCheckbox 
                    checked={user.hide_in_invoice ? true : false}
                    onChange={() => {
                        let newSplits = clone(dataField);
                        newSplits[index].hide_in_invoice = newSplits[index].hide_in_invoice ? false : true;
                        updateDataObj(field, newSplits);
                    }}
                    label="Hide in Invoice"
                />
                ,
                <IconButton
                    onClick={() => {
                        let newSplits = clone(dataField);
                        const idToRemove = get(newSplits, `[${index}].id`, '');
                        const newData = clone(data);

                        const contact_ids = get(newData, `chosen.${field}.contact`, []).filter(id => id !== idToRemove);
                        set(newData, `chosen.${field}.contact`, contact_ids);
                        newSplits.splice(index, 1);

                        newData[field] = newSplits;
                        setData(newData)
                    }}
                >
                    <i className="fas fa-trash-alt red-text"></i>
                </IconButton>,
            ];
        });

        const total =
            dataField
                .map((acc) => {
                    if (acc.Percentage === "" || isNaN(acc.Percentage)) {
                        acc.Percentage = "0";
                        return acc;
                    } else {
                        return acc;
                    }
                })
                .reduce((acc, curr) => {
                    return acc + parseFloat(curr.Percentage);
                }, 0) + "%";

        const totalText = () => (total === "100%" ? total : <span className="red-text">{total}</span>);

        tableData.push(["Total", totalText(), ""]);

        return tableData;
    };

    // LESSOR TABLE
    let lessorTableData = [
        [
            `${lessorLabel} Referral ${
                data.referral_firm_name || data.referral_firm_lastname
                    ? `- ${data.referral_firm_name} ${data.referral_firm_lastname}`
                    : ""
            }
            ${data.referral_firm_contact_dba_name ? `DBA ${data.referral_firm_contact_dba_name }` : ''}
            ${data.referral_firm_contact_dba_active === 0 ? ' (removed)' : ''}
            `,
            data.referral_firm_fee_amount_choice === "Value"
                ? data.referral_firm_fee_amount
                : get(data, 'referral_firm_fee_amount_percentage', '') + " %",
        ]
    ];
    if (!hideLessorOutsideBroker) {
        data.lessor_outside_broker.forEach(ob => {
            lessorTableData.push([
                `Lessor Outside Broker - ${ob.company_name ? theVal(ob.company_name) : theVal(ob.first_name) + ' ' + theVal(ob.last_name)}`,
                 theVal(ob.commission) + " %",
            ])
        })
    }

    // LESSEE TABLE
    let lesseeTableData = [
        [
            `${lesseeLabel} Referral ${
                data.lessee_referral_firm_name || data.lessee_referral_firm_lastname
                    ? `- ${data.lessee_referral_firm_name} ${data.lessee_referral_firm_lastname}`
                    : ""
            }  
            ${data.lessee_referral_firm_contact_dba_name ? `DBA ${data.lessee_referral_firm_contact_dba_name }` : ''}
            ${data.lessee_referral_firm_contact_dba_active === 0 ? ' (removed)' : ''}
            `,
            data.lessee_referral_firm_fee_amount_choice === "Value"
                ? data.lessee_referral_firm_fee_amount
                : get(data, 'lessee_referral_firm_fee_amount_percentage', '') + " %",
        ]
    ];

    const chooseAgent = (the_contact_data, filler, dba) => {
        if (the_contact_data?.signers && the_contact_data?.signers.length > 0) {
            the_contact_data = the_contact_data.signers[0];
        }
        getContact(the_contact_data.id);
        let newSplits = clone(data.commission_splits_agent);
        newSplits.push({
            id: the_contact_data.id,
            Name: `${the_contact_data.first_name} ${the_contact_data.last_name}`,
            Percentage: "0",
            dba_name: dba?.name,
            dba_id: dba?.id,
            dba_type: 'contact',
        });

        const newData = clone(data);
        newData.commission_splits_agent = newSplits

        const contact_ids = get(newData, `chosen.commission_splits_agent.contact`, [])
        contact_ids.push(the_contact_data.id);
        set(newData, `chosen.commission_splits_agent.contact`, contact_ids)
        setData(newData)

        setAddAgent(false);
    }

    const chooseAgent2 = (the_contact_data, filler, dba) => {
        if (the_contact_data?.signers && the_contact_data?.signers.length > 0) {
            the_contact_data = the_contact_data.signers[0];
        }
        getContact(the_contact_data.id);
        let newSplits = clone(data.commission_splits_agent2);
        newSplits.push({
            id: the_contact_data.id,
            Name: `${the_contact_data.first_name} ${the_contact_data.last_name}`,
            Percentage: "0",
            dba_name: dba?.name,
            dba_id: dba?.id,
            dba_type: 'contact',
        });

        const newData = clone(data);
        newData.commission_splits_agent2 = newSplits;

        const contact_ids = get(newData, `chosen.commission_splits_agent2.contact`, []);
        contact_ids.push(the_contact_data.id);
        set(newData, `chosen.commission_splits_agent2.contact`, contact_ids);
        setData(newData)

        // updateDataObj("commission_splits_agent2", newSplits);
        setAddAgent2(false);
    }

    // ASSIGNOR
    const chooseAgent3 = (the_contact_data, filler, dba) => {
        if (the_contact_data?.signers && the_contact_data?.signers.length > 0) {
            the_contact_data = the_contact_data.signers[0];
        }
        getContact(the_contact_data.id);
        let newSplits = clone(data.commission_splits_agent3 ? data.commission_splits_agent3 : []);
        newSplits.push({
            id: the_contact_data.id,
            Name: `${the_contact_data.first_name} ${the_contact_data.last_name}`,
            Percentage: "0",
            dba_name: dba?.name,
            dba_id: dba?.id,
            dba_type: 'contact',
        });

        const newData = clone(data);
        newData.commission_splits_agent3 = newSplits;

        const contact_ids = get(newData, `chosen.commission_splits_agent3.contact`, []);
        contact_ids.push(the_contact_data.id);
        set(newData, `chosen.commission_splits_agent3.contact`, contact_ids);
        setData(newData)

        setAddAgent3(false);
    }

    lesseeTableData = lesseeTableData.concat(data.outside_broker.map(ob => {
        return [
            `Outside Broker - ${ob.company_name ? theVal(ob.company_name) : theVal(ob.first_name) + ' ' + theVal(ob.last_name)}`,
             theVal(ob.commission) + " %",
        ];
    }));

    console.log('lesseeTableData', lesseeTableData);

    const all_commission_calculations = commissionCalc.calculate(data);
    console.log('all_commission_calculations', all_commission_calculations);
    
    const lessor_is_active = determineIfActive(data, 'lessor');
    const lessee_is_active = determineIfActive(data, 'lessee');
    const assignor_is_active = determineIfActive(data, 'assignor');

    return (
        <div>
            <GridContainer>
                {/* LESSEE */}
                <GridItem xs={12} sm={12} md={12}>
                    {lessee_is_active && <div className="boxed">
                            <GridItem xs={12} sm={12} md={12}>
                                <h3 style={{textTransform: 'uppercase', fontWeight: 'bold'}}>{lesseeLabel}</h3>
                            </GridItem>
                        {hasLesseeAssociate && <>
                            <GridItem xs={12} sm={12} md={12}>
                                {data.commission_splits_agent2 && data.commission_splits_agent2.length > 0 && (
                                    <div className={!lessee_is_active ? 'grayed-out' : ''}>
                                        <Table
                                            tableHeaderColor="primary"
                                            tableHead={["Name", "Percentage", "Delete"]}
                                            tableData={buildAgentTableData("Lessee")}
                                        />
                                    </div>
                                )}
                            </GridItem>
                            <GridItem container justify="flex-end" xs={12} sm={12} md={12}>
                                {lessee_is_active && <Button
                                    color="primary"
                                    onClick={() => {
                                        setAddAgent2(true);
                                    }}
                                >
                                    <i className="fa fa-plus"></i> ADD ASSOCIATE
                                </Button>}
                            </GridItem>
                        </>}
                        <GridItem xs={12} sm={8} md={8}>
                            <hr />
                            <h3>OUTSIDE BROKERS</h3>
                            <Table
                                tableHeaderColor="primary"
                                tableHead={["Name", "Percentage", "Value"]}
                                tableData={all_commission_calculations.lessee_outside_brokers.map(lob => {
                                    return [
                                        lob.name,
                                        lob.percentage !== 'N/A' ? twoDecimals(lob.percentage * 100) + ' %' : 'N/A',
                                        '$' + twoDecimals(lob.value)
                                    ];
                                })}
                            />
                            <hr />
                            <h3>REFERRALS</h3>
                            <Table
                                tableHeaderColor="primary"
                                tableHead={["Name", "Percentage", "Value"]}
                                tableData={all_commission_calculations.lessee_referrals.map(lr => {
                                    return [
                                        lr.name,
                                        lr.percentage !== 'N/A' ? twoDecimals(lr.percentage * 100) + ' %' : 'N/A',
                                        '$' + twoDecimals(lr.value)
                                    ];
                                })}
                            />
                            <hr />
                            <div>
                                {lesseeLabel} Commission Distribution: {
                                    parseFloatString(all_commission_calculations.commission_distribution_lessee_percent) * 100
                                }%
                            </div>
                            <div>
                                {lesseeLabel} Commission: {
                                    formatDollar(parseFloatString(all_commission_calculations.commission_distribution_lessee))
                                }
                            </div>
                            <div>
                                {lesseeLabel} Pre-split Commission: {
                                    formatDollar(parseFloatString(all_commission_calculations.commission_distribution_lessee - all_commission_calculations.commission_distribution_lessee_after_presplits))
                                }
                            </div>
                            <div className={all_commission_calculations.total_lessee === all_commission_calculations.commission_distribution_lessee ?
                                    ''
                                :
                                    ''
                            }>
                                {lesseeLabel} Total Commission: {
                                    formatDollar(parseFloatString(all_commission_calculations.total_lessee - (all_commission_calculations.commission_distribution_lessee - all_commission_calculations.commission_distribution_lessee_after_presplits)))
                                }
                            </div>
                        </GridItem>
                    </div>}
                </GridItem>

                {/* ASSIGNOR */}
                <GridItem xs={12} sm={12} md={12}>
                    {assignor_is_active && <div className="boxed">
                            <GridItem xs={12} sm={12} md={12}>
                                <h3 style={{textTransform: 'uppercase', fontWeight: 'bold'}}>Assignor</h3>
                            </GridItem>
                        {hasAssignorAssociate && <>
                            <GridItem xs={12} sm={12} md={12}>
                                {data.commission_splits_agent3 && data.commission_splits_agent3.length > 0 && (
                                    <div className={!assignor_is_active ? 'grayed-out' : ''}>
                                        <Table
                                            tableHeaderColor="primary"
                                            tableHead={["Name", "Percentage", "Delete"]}
                                            tableData={buildAgentTableData("Assignor")}
                                        />
                                    </div>
                                )}
                            </GridItem>
                            <GridItem container justify="flex-end" xs={12} sm={12} md={12}>
                                {assignor_is_active && <Button
                                    color="primary"
                                    onClick={() => {
                                        setAddAgent3(true);
                                    }}
                                >
                                    <i className="fa fa-plus"></i> ADD ASSOCIATE
                                </Button>}
                            </GridItem>
                        </>}
                        <GridItem xs={12} sm={8} md={8}>
                            <hr />
                            <h3>OUTSIDE BROKERS</h3>
                            <Table
                                tableHeaderColor="primary"
                                tableHead={["Name", "Percentage", "Value"]}
                                tableData={all_commission_calculations.assignor_outside_brokers.map(lob => {
                                    return [
                                        lob.name,
                                        lob.percentage !== 'N/A' ? twoDecimals(lob.percentage * 100) + ' %' : 'N/A',
                                        '$' + twoDecimals(lob.value)
                                    ];
                                })}
                            />
                            <hr />
                            <div>
                                Assignor Commission Distribution: {
                                    parseFloatString(all_commission_calculations.commission_distribution_assignor_percent) * 100
                                }%
                            </div>
                            <div>
                                Assignor Commission: {
                                    formatDollar(parseFloatString(all_commission_calculations.commission_distribution_assignor))
                                }
                            </div>
                            <div>
                                Assignor Pre-split Commission: {
                                    formatDollar(parseFloatString(all_commission_calculations.commission_distribution_assignor - all_commission_calculations.commission_distribution_assignor_after_presplits))
                                }
                            </div>
                            <div className={all_commission_calculations.total_assignor === all_commission_calculations.commission_distribution_assignor ?
                                    ''
                                :
                                    ''
                            }>
                                Assignor Total Commission: {
                                    formatDollar(parseFloatString(all_commission_calculations.total_assignor - (all_commission_calculations.commission_distribution_assignor - all_commission_calculations.commission_distribution_assignor_after_presplits)))
                                }
                            </div>
                        </GridItem>
                    </div>}
                </GridItem>

                {/* LESSOR */}
                <GridItem xs={12} sm={12} md={12}>
                    {lessor_is_active && <div className="boxed">
                            <GridItem xs={12} sm={12} md={12}>
                                <h3 style={{textTransform: 'uppercase', fontWeight: 'bold'}}>{lessorLabel}</h3>
                            </GridItem>
                        {hasLessorAssociate && <>
                            <GridItem xs={12} sm={12} md={12}>
                                {data.commission_splits_agent && data.commission_splits_agent.length > 0 && (
                                    <div className={!lessor_is_active ? 'grayed-out' : ''}>
                                        <Table
                                            tableHeaderColor="primary"
                                            tableHead={["Name", "Percentage", "Delete"]}
                                            tableData={buildAgentTableData("Lessor")}
                                        />
                                    </div>
                                )}
                            </GridItem>
                            <GridItem container justify="flex-end" xs={12} sm={12} md={12}>
                                {lessor_is_active && <Button
                                    color="primary"
                                    onClick={() => {
                                        setAddAgent(true);
                                    }}
                                >
                                    <i className="fa fa-plus"></i> ADD ASSOCIATE
                                </Button>}
                            </GridItem>
                        </>}
                        <GridItem xs={12} sm={8} md={8}>
                            <hr />
                            <h3>OUTSIDE BROKERS</h3>
                            <Table
                                tableHeaderColor="primary"
                                tableHead={["Name", "Percentage", "Value"]}
                                tableData={all_commission_calculations.lessor_outside_brokers.map(lob => {
                                    return [
                                        lob.name,
                                        lob.percentage !== 'N/A' ? twoDecimals(lob.percentage * 100) + ' %' : 'N/A',
                                        '$' + twoDecimals(lob.value)
                                    ];
                                })}
                            />
                            <hr />
                            <h3>REFERRALS</h3>
                            <Table
                                tableHeaderColor="primary"
                                tableHead={["Name", "Percentage", "Value"]}
                                tableData={all_commission_calculations.lessor_referrals.map(lr => {
                                    return [
                                        lr.name,
                                        lr.percentage !== 'N/A' ? twoDecimals(lr.percentage * 100) + ' %' : 'N/A',
                                        '$' + twoDecimals(lr.value)
                                    ];
                                })}
                            />
                            <hr />
                            <div>
                                {lessorLabel} Commission Distribution: {
                                    parseFloatString(all_commission_calculations.commission_distribution_lessor_percent) * 100
                                }%
                            </div>
                            <div>
                                {lessorLabel} Commission: {
                                    formatDollar(parseFloatString(all_commission_calculations.commission_distribution_lessor))
                                }
                            </div>
                            <div>
                                {lessorLabel} Pre-split Commission: {
                                    formatDollar(parseFloatString(all_commission_calculations.commission_distribution_lessor - all_commission_calculations.commission_distribution_lessor_after_presplits))
                                }
                            </div>
                            <div className={all_commission_calculations.total_lessor === all_commission_calculations.commission_distribution_lessor ?
                                    ''
                                :
                                    ''
                            }>
                                {lessorLabel} Total Commission: {
                                    formatDollar(parseFloatString(all_commission_calculations.total_lessor - (all_commission_calculations.commission_distribution_lessor - all_commission_calculations.commission_distribution_lessor_after_presplits)))
                                }
                            </div>
                        </GridItem>
                    </div>}
                    
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                    <div className="boxed">
                        <Button
                            color="primary"
                            onClick={() => {
                                const newData = clone(data);
                                if (!newData.invoiceOnlyAgents) {
                                    newData.invoiceOnlyAgents = [];
                                }
                                newData.invoiceOnlyAgents.push({
                                    Name: ''
                                });
                                setData(newData);
                            }}
                        >
                            <i className="fa fa-plus"></i> ADD INVOICE ONLY ASSOCIATE NAME
                        </Button>
                        {data.invoiceOnlyAgents && <div>
                            {data.invoiceOnlyAgents.map((dia,y) => {
                                return <div key={`${y}-ss`}>
                                    <h4># {y+1}</h4>
                                    <div style={{float:'right'}}>
                                        <IconButton
                                            onClick={() => {
                                                const newData = clone(data);
                                                newData.invoiceOnlyAgents = data.invoiceOnlyAgents.filter((ddia,yy) => {
                                                    if (yy === y) {
                                                        return false;
                                                    }
                                                    return true;
                                                });
                                                setData(newData);
                                            }}
                                        >
                                            <i className="red-text fa fa-trash"></i>
                                        </IconButton>
                                    </div>
                                    <CustomInput
                                        label="Associate Name"
                                        validate={[]}
                                        value={dia.Name}
                                        onChange={(e) => {
                                            const newData = clone(data);
                                            newData.invoiceOnlyAgents = data.invoiceOnlyAgents.map((ddia,yy) => {
                                                if (yy === y) {
                                                    ddia.Name = e.target.value;
                                                }
                                                return ddia;
                                            });
                                            setData(newData);
                                        }}
                                    />
                                </div>
                            })}
                        </div>}
                    </div>
                </GridItem>

                {addAgent && <CustomDialogWithContact
                        open={addAgent}
                        close={() => {
                            setAddAgent(false);
                        }}
                        choose={chooseAgent}
                        peopleType="agents"
                        create_and_choose={chooseAgent}
                        title="Select Contact"
                        label="Search Contacts"
                    />}
                {addAgent2 &&  <CustomDialogWithContact
                    open={addAgent2}
                    close={() => {
                        setAddAgent2(false);
                    }}
                    choose={chooseAgent2}
                    peopleType="agents"
                    create_and_choose={chooseAgent2}
                    title="Select Contact"
                    label="Search Contacts"
                />}
                {addAgent3 &&  <CustomDialogWithContact
                    open={addAgent3}
                    close={() => {
                        setAddAgent3(false);
                    }}
                    choose={chooseAgent3}
                    peopleType="agents"
                    create_and_choose={chooseAgent3}
                    title="Select Contact"
                    label="Search Contacts"
                />}

                <GridItem xs={12} sm={12} md={12}>
                    <AttachedCommissionSplits data={data} setData={setData} />
                </GridItem>
            </GridContainer>
        </div>
    );
};

export default CommissionSplits;

export const CommissionSplitsAssociateFull = (props) => {
    const [associateSelectModalOpen, setAssociateSelectModalOpen] = useState(false);
    let showValue = false;
    const usr = getUser();
    if (usr.permObj.hasOwnProperty('Routing view_associate_splits')) {
        showValue = true;
    }

    if (!showValue) return null;
    const acc = props.all_commission_calculations;
    let lessee_tot = 0;
    let lessee_perc_tot = 0;
    let lessor_tot = 0;
    let lessor_perc_tot = 0;
        
    return <div className="boxed mt-20">
        <div style={{marginTop:20}}>
            <h4 style={{ textDecoration: "underline" }}>ASSOCIATE COMMISSION SPLITS LESSEE</h4>
        </div>
        <div className="the-table" style={{marginTop:20}}>
            <table>
                <tbody>
                    <tr>
                        <td className="col-30">
                            <strong>Name</strong>
                        </td>
                        <td className="col-30">
                            <strong>Percentage</strong>
                        </td>
                        <td className="col-40">
                            <strong>Value</strong>
                        </td>
                    </tr>
                    {acc.associate_commission_splits_lessee.map((c, i) => {
                        const whole_perc = c.perc * 100;
                        lessee_tot += c.value;
                        console.log('adding-', whole_perc, lessee_perc_tot);
                        lessee_perc_tot += whole_perc;
                        return (
                            <tr key={`${i}-agent`}>
                                <td className="col-30">{c.name}</td>
                                <td className="col-30">{twoDecimals(parseFloatString(c.perc * 100))} %</td>
                                <td className="col-40">${twoDecimals(c.value)}</td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td className="col-30">
                            <strong>Total</strong>
                        </td>
                        <td className="col-30">{twoDecimals(lessee_perc_tot)} %</td>
                        <td className="col-40">${twoDecimals(lessee_tot)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div style={{marginTop:20}}>
            <h4 style={{ textDecoration: "underline" }}>ASSOCIATE COMMISSION SPLITS LESSOR </h4>
        </div>
        <div className="the-table" style={{marginTop:20}}>
            <table>
                <tbody>
                    <tr>
                        <td className="col-30">
                            <strong>Name</strong>
                        </td>
                        <td className="col-30">
                            <strong>Percentage</strong>
                        </td>
                        <td className="col-40">
                            <strong>Value</strong>
                        </td>
                    </tr>
                    {acc.associate_commission_splits_lessor.map((c, i) => {
                        const whole_perc = c.perc * 100;
                        lessor_tot += c.value;
                        console.log('adding-', whole_perc, lessor_perc_tot);
                        lessor_perc_tot += whole_perc;
                        return (
                            <tr key={`${i}-agent`}>
                                <td className="col-30">{c.name}</td>
                                <td className="col-30">{twoDecimals(parseFloatString(c.perc * 100))} %</td>
                                <td className="col-40">${twoDecimals(c.value)}</td>
                            </tr>
                        );
                    })}
                    <tr>
                        <td className="col-30">
                            <strong>Total</strong>
                        </td>
                        <td className="col-30">{twoDecimals(lessor_perc_tot)} %</td>
                        <td className="col-40">${twoDecimals(lessor_tot)}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        {associateSelectModalOpen && <CustomDialogWithContact
            open={true}
            close={() => {
                setAssociateSelectModalOpen(false);
            }}
            choose={(the_contact_data, filler, dba) => {
                console.log('thecont', the_contact_data, filler, dba);
                let contact = the_contact_data;

                console.log(contact, dba);
                // check if user picked a contact from a company
                if (contact.signers && contact.signers.length > 0) {
                    contact = contact.signers[0];
                }

                const newAgents = clone(agents);
                const found = newAgents.find((ag) => ag.id === contact.id);
                if (!found) {
                    newAgents.push({
                        id: contact.id,
                        name: contact.first_name,
                        last_name: contact.last_name,
                        dba_name: dba?.name,
                        dba_id: dba?.id,
                        dba_type: 'contact',
                    });
                }

                const newData = clone(data);
                newData[field] = newAgents;

                const contact_ids = get(newData, `chosen.${queryFor}.contact`, [])
                contact_ids.push(contact.id);

                set(newData, `chosen.${queryFor}.contact`, contact_ids);
                setData(newData);
                
                // updateDataObj(field, newAgents);
                // setContactModalOpen(false);
                setAssociateSelectModalOpen(false);
            }}
            peopleType="agents"
            create_and_choose={(the_contact_data, filler, dba) => {
                let contact = the_contact_data;

                console.log(contact, dba);
                // check if user picked a contact from a company
                if (contact.signers && contact.signers.length > 0) {
                    contact = contact.signers[0];
                }

                const newAgents = clone(agents);
                const found = newAgents.find((ag) => ag.id === contact.id);
                if (!found) {
                    newAgents.push({
                        id: contact.id,
                        name: contact.first_name,
                        last_name: contact.last_name,
                        dba_name: dba?.name,
                        dba_id: dba?.id,
                        dba_type: 'contact',
                    });
                }

                const newData = clone(data);
                newData[field] = newAgents;

                const contact_ids = get(newData, `chosen.${queryFor}.contact`, [])
                contact_ids.push(contact.id);

                set(newData, `chosen.${queryFor}.contact`, contact_ids);
                setData(newData);
                
                setAssociateSelectModalOpen(false);
            }}
            title="Select Contact"
            label="Search Contacts"
        />}
    </div>
}
